import React from "react";
import AboutCard from "./aboutCard";
// import Work from '../../Images/New/Whay_us/Work.svg'
// import Wallet from '../../Images/New/Whay_us/Wallet.svg'
// import Check from '../../Images/New/Whay_us/person_check.svg'
// import Bounding from '../../Images/New/Whay_us/person_bounding.svg'
// import Time from '../../Images/New/Whay_us/time.svg'
// import Video from '../../Images/New/Whay_us/video_1.svg'

const About = () => {
  const data = [
    {
      title: "Ease of Use",
      disc: "Simplify your workload with EasyTDS, your go-to solution for seamless efficiency.",
      // icon: Work,
    },
    {
      title: "Price Competitive",
      disc: "Accurate, Reliable and Cost effective, EasyTDS delivers value without compromise.",
      // icon: Wallet,
    },
    {
      title: "Guided Demo",
      disc: "Learn how EasyTDS can make TDS management effortless",
      // icon: Check,
    },
    {
      title: "Trial Version",
      disc: "Try EasyTDS demo version and discover it's full potention before you buy licence software.",
      // icon: Bounding,
    },
    {
      title: "Tech Support",
      disc: "Experts are always here to help you keep EasyTDS running Smootly.",
      // icon: Time,
    },
    {
      title: "Trusted by Tax Professionals",
      disc: "EasyTDS trusted by Chartered Accountants & Tax Protessionals globally for its accuracy & efficiency.",
      // icon: Video,
    },
  ];

  return (
    <div className="relative z-40 bg-white w-full">
      <div className="max-w-7xl mx-auto sm:px-5 px-3 py-12">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-gray-900">
            Why Choose{" "}
            <span
              className="font-extrabold"
              style={{
                backgroundImage:
                  "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Us?
            </span>
          </h2>
          <p className="mt-2 text-2xl text-gray-800 italic">
            The Best TDS & TCS Return Filing Software
          </p>
        </div>
        <div className="mt-12 space-y-10 sm:space-y-0 sm:grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {data.map((item, index) => (
            <AboutCard
              key={index}
              // icon={item.icon}
              title={item.title}
              disc={item.disc}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
